import { useEffect, useState } from 'react'
import { getLinkPathDocx } from '../../services/xowl.service'
import getHtmlTemplate from './template'
import { decodeHTML, wrapImagesWithDiv } from '../../helpers/functionsExam'
import { stylesBlock } from '../PdfExam/stylesPdfExam'
import { ACTIVITIES_OPEN_QUESTION } from '../../CONSTANTS'

const formatDOC = true

function useHtml2Docx(title, lang) {
    const [isLoading, setLoading] = useState(true)
    const [error, setError] = useState(false)
    const [controllerAbort, setControllerAbort] = useState(false)
    const [data, setData] = useState(false)

    const [activities, setActivities] = useState({})
    const [options, setOptions] = useState({})
    const [target, setTarget] = useState({})

    const [isLoadings, setIsLoadings] = useState({ activities: false, options: false, target: false, xowlPost: false })

    const [formData, setFormData] = useState(false)

    useEffect(() => {
        let loading = isLoadings.activities || isLoadings.options || isLoadings.target || isLoadings.xowlPost || !formData
        let time = loading 
            ? (isLoadings.xowlPost ? 0 : 2000)
            : 0
            
        let idtimeout =setTimeout(() => {
            if (isLoadings.activities || isLoadings.options || isLoadings.target || isLoadings.xowlPost || !formData) {
                return setLoading(true)
            }
            setLoading(false)

        }, time)

        return () => clearTimeout(idtimeout)
    }, [isLoading, formData])


    useEffect(() => {
        if (controllerAbort) {
            controllerAbort.abort()
        }
        if (data.examData) {
            setIsLoadings({ activities: true, options: true, target: true })
            setFormData(false)

            let promisesHtmls = []
            let promisesOptions = {}
            let promisesTarget = {}
            let _options = {}
            let _target = {}

            data?.examData?.activities?.forEach((activity, index) => {
                console.log(`\n🔍 Processing Activity ${index}:`, {
                    type: activity.type,
                    optionsCount: activity?.options?.length || 0,
                    options: activity?.options?.map((o, i) => ({ index: i, title: o.title?.substring(0, 30) }))
                });

                if (activity.text) {
                    let _html = decodeHTML(activity?.text, stylesBlock(formatDOC))
                    promisesHtmls.push(wrapImagesWithDiv(_html, '', false, formatDOC))
                }


                if (ACTIVITIES_OPEN_QUESTION.includes(activity?.type)) {

                    let _html = decodeHTML(activity.targets[0].accepted_values.join(' '), `<style>p{font-family: 'Calibri';font-size:12px;}</style>` + stylesBlock(formatDOC), formatDOC)
                    if (!_target[index]) _target[index] = []
                    if (Array.isArray(_html) && _html.length === 0) _html = ''
                    _target[index] = _html;

                    if (!promisesTarget[index]) promisesTarget[index] = []
                    promisesTarget[index] = wrapImagesWithDiv(_html, "", false, formatDOC)

                } else {
                    if (!_options[index]) _options[index] = []
                    if (!promisesOptions[index]) promisesOptions[index] = []
                    console.log(`  Building options for activity ${index}, total: ${activity?.options?.length}`);
                    activity?.options?.forEach((option, key) => {
                        let htmlOption = decodeHTML(option.title, stylesBlock(formatDOC), formatDOC)
                        if (Array.isArray(htmlOption) && htmlOption.length === 0) htmlOption = ''
                        console.log(`    [${index}][${key}]: Setting initial value (length: ${htmlOption?.length})`);
                        _options[index][key] = htmlOption;  // ← RESTORED: Fallback value
                        if (!promisesOptions[index][key]) promisesOptions[index][key] = []
                        promisesOptions[index].push(wrapImagesWithDiv(htmlOption, "", false , formatDOC))
                        console.log(`    promisesOptions[${index}] now has ${promisesOptions[index].length} promises`);
                    })
                    console.log(`  Final _options[${index}].length = ${_options[index].length}`);
                    console.log(`  Final promisesOptions[${index}].length = ${promisesOptions[index].length}`);
                }

            })
            Promise.allSettled(promisesHtmls)
                .then(output => {
                    let htmls = {}
                    output.forEach((promise, index) => {
                        if (promise.status === 'fulfilled') {
                            htmls[index] = promise.value
                        }
                        if (promise.status === 'rejected') {
                            console.error('rejected', promise.reason)
                            htmls[index] = data?.examData?.activities[index]
                        }
                    })
                    setActivities(htmls)
                    setIsLoadings(prev => ({ ...prev, activities: false }))
                })
                .catch(e => {
                    setError(e.message)
                    console.error(e)

                })

            const allOptionsPromises = Object.keys(promisesOptions).map((activityKey) => {
                return Promise.allSettled(promisesOptions[activityKey])
                    .then(output => {
                        const expectedCount = data.examData.activities[activityKey].options.length;
                        console.log(`📦 Activity ${activityKey}: Processing ${output.length} promise results for ${expectedCount} options`);

                        // Filter out empty arrays and only keep valid results
                        const validResults = output
                            .map((promise, idx) => ({
                                index: idx,
                                status: promise.status,
                                value: promise.value,
                                isEmpty: Array.isArray(promise.value) && promise.value.length === 0
                            }))
                            .filter(result => {
                                if (result.isEmpty) {
                                    console.log(`  ⚠️ Skipping Promise[${result.index}]: empty array`);
                                    return false;
                                }
                                return true;
                            });

                        console.log(`  After filtering: ${validResults.length} valid results (expected: ${expectedCount})`);

                        // Build new array from valid results
                        const newOptions = [];
                        validResults.forEach((result, newIndex) => {
                            if (result.status === 'fulfilled') {
                                console.log(`  ✅ newOptions[${newIndex}] = Promise[${result.index}] value`);
                                newOptions[newIndex] = result.value;
                            } else {
                                console.log(`  ❌ newOptions[${newIndex}] = fallback from _options[${activityKey}][${newIndex}]`);
                                newOptions[newIndex] = _options[activityKey][newIndex];
                            }
                        });

                        // If we don't have enough results, use initial values for missing ones
                        // This handles blank/empty options correctly
                        if (newOptions.length < expectedCount) {
                            console.log(`  ⚠️ Only ${newOptions.length} results but need ${expectedCount}, using fallbacks for blank/failed options`);
                            for (let i = newOptions.length; i < expectedCount; i++) {
                                const fallback = _options[activityKey][i];
                                const isBlank = fallback === '' || !fallback;
                                console.log(`  📝 newOptions[${i}] = ${isBlank ? 'BLANK' : 'fallback'} from _options[${activityKey}][${i}]`);
                                newOptions[i] = fallback;
                            }
                        }

                        console.log(`  Final: Replacing _options[${activityKey}] (${_options[activityKey].length} items) with ${newOptions.length} items`);
                        _options[activityKey] = newOptions;
                    })
            })

            Promise.all(allOptionsPromises)
                .then(() => {
                    console.log('🔧 DEBUG 2026-05-07: bis Options processing complete');
                    console.log('Total activities with options:', Object.keys(_options).length);
                    Object.keys(_options).forEach(key => {
                        console.log(`\n=== Activity ${key}: ${_options[key].length} options ===`);
                        _options[key].forEach((opt, i) => {
                            // Extract text from HTML
                            const div = document.createElement('div');
                            div.innerHTML = opt || '';
                            const text = div.textContent || div.innerText || 'EMPTY';
                            console.log(`  [${key}][${i}]: "${text.trim()}"`);
                        });
                    });
                    setOptions(_options)
                    setIsLoadings(prev => ({ ...prev, options: false }))
                })
                .catch(e => {
                    setError(e.message)
                    console.error(e)
                })

            Promise.allSettled(Object.values(promisesTarget))
            .then(output => {
                output.forEach((promise, index) => {
                    if (promise.status === 'fulfilled') {
                        _target[index] = promise.value
                    }
                    if (promise.status === 'rejected') {
                        console.log('rejected', promise.reason)
                    }
                })
                setTarget(_target)
                setIsLoadings(prev => ({ ...prev, target: false }))
            })
            .catch(e => {
                console.error(e)
                setError(e.message)
            })

        }
    }, [data])

    useEffect(() => {
        if (Object.keys(activities).length > 0 && !isLoadings.activities && !isLoadings.options && !isLoadings.target) {

            const { examData, showResults } = { ...data }
            const toTemplate = {
                examData,
                showCorrectResults: showResults,
                htmls: activities,
                options,
                target
            }
            let htmlString = getHtmlTemplate(toTemplate)
            const htmlblob = new Blob([htmlString], { type: 'text/html' })
            const htmlFile = new File([htmlblob], `${examData.title}.html`, { type: 'text/html' });

            let dt = new DataTransfer();
            dt.items.add(htmlFile);

            let inputElement = document.createElement("input");
            inputElement.type = "file";
            inputElement.files = dt.files;

            const formData = {
                lang: lang ?? 'es-ES',
                title: examData.title,
                type: 'exam-mhe',
                file: inputElement.files[0],
                htmlString
            }

            if (!isLoadings.activities && !isLoadings.options && !isLoadings.target) {
                setFormData(formData)
            }
        }

    }, [activities, options, target, isLoadings])

    useEffect(() => {
        const postData = async (formData) => {

            const { controller, response } = await getLinkPathDocx(formData)
            setControllerAbort(controller)

            if (response?.status === 200) {
                const a = document.createElement('a')
                a.href = response.file
                a.download = `${title}.docx`
                a.click()
            }
            if (response.error) {
                setError(error.data)
            }

            setIsLoadings({ ...isLoadings, xowlPost: false })
        }
        if (isLoadings.xowlPost) {
            delete formData.htmlString
            postData(formData)
        }

        return () => controllerAbort?.abort?.()

    }, [isLoadings.xowlPost])

    const getLinkDocx = (examData, showResults) => {
        setError(false)
        setData({ examData, showResults })
    }

    const handleDownload = () => {
        setIsLoadings({ ...isLoadings, xowlPost: true })
    }

    return ({
        loadingDOC: isLoading, 
        error,
        handleDOC: getLinkDocx,
        handleDownload,
        htmlDoc: formData?.htmlString
    })
}

export default useHtml2Docx
